// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xbG-","badges":"styles_badges__24hJg"};